import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./core/redux/store";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import LocalStorageService from "./core/services/local-storage-service";
import Authenticate from "pages/middle-layer-handler/authenticate";

const localStorageService = LocalStorageService.getService();
const root = ReactDOM.createRoot(document.getElementById("root"));
let userDetails = localStorageService.getUserDetails();

function includeSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_KEY,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
      }),
      new Sentry.Replay(),
    ],
    release: process.env.REACT_APP_BRANCH + "_" + process.env.REACT_APP_COMMIT_ID,
    initialScope: (scope) => {
      scope.setTags({ userDetails: userDetails?.email_address });
      return scope;
    },
    ignoreErrors: [
      "TypeError: Failed to fetch",
      "TypeError: NetworkError when attempting to fetch resource.",
      "TypeError: Cancelled",
      "TypeError: Request failed with status code 401",
      "Cannot read properties of null (reading 'sessionId')",
      "Cannot read properties of null (reading 'sequence')",
      "Request failed with status code 401",
      "Request aborted",
      "Network Error",
      "Request failed with status code 502",
      "Request failed with status code 503",
      "Request failed with status code 504",
      "timeout exceeded",
    ],
    denyUrls: [/clarity\.js/i, /clarity\.ms/i, /^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari-(web-)?extension:\/\//i],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

function includePendo() {
  window.pendo.initialize({
    visitor: {
      id: !!userDetails && !!userDetails.email_address && userDetails.email_address !== "" ? userDetails.email_address : "",
    },

    account: {
      id: !!userDetails && !!userDetails.email_address && userDetails.email_address !== "" ? userDetails.email_address : "",
    },
  });
}
function handleConsoles() {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

if (process.env.NODE_ENV.toLowerCase() === "production") {
  handleConsoles();
  includePendo();
  includeSentry();
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Authenticate>
        <App />
      </Authenticate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
